import { useContext, useCallback } from 'react';
import poolContext from './poolContext';
import { LockUpType, LiquidityPoolType, PoolTypes } from './poolTypes';

const usePoolState = (): PoolTypes => {
    const context = useContext(poolContext);

    if (!Object.keys(context).length) {
        throw new Error('PoolContext must be used within its provider');
    }

    const { dispatch } = context;

    const setSelectedPool = (pool: LiquidityPoolType) =>
        dispatch({
            type: 'SET_SELECTED_POOL',
            payload: pool,
        });

    const toggleDepositInterface = () =>
        dispatch({
            type: 'TOGGLE_DEPOSIT_INTERFACE',
        });

    const toggleWithdrawInterface = () => dispatch({ type: 'TOGGLE_WITHDRAW_INTERFACE' });

    const toggleExposure = () => dispatch({ type: 'TOGGLE_EXPOSURE' });

    const setSelectedLockUp = (lockUp: LockUpType) =>
        dispatch({ type: 'SET_SELECTED_LOCK_UP', payload: lockUp });

    const setDepositAmount = (amount: string) =>
        dispatch({ type: 'SET_DEPOSIT_AMOUNT', payload: amount });

    const setWithdrawAmount = (amount: string) =>
        dispatch({
            type: 'SET_WITHDRAW_AMOUNT',
            payload: amount,
        });

    const resetPoolState = useCallback(
        () => dispatch({ type: 'RESET_POOL_STATE' }),
        [dispatch]
    );

    return {
        ...context,
        setSelectedLiquidityPool: setSelectedPool,
        toggleDepositInterface,
        toggleWithdrawInterface,
        toggleExposure,
        setSelectedLockUp,
        setDepositAmount,
        setWithdrawAmount,
        resetPoolState,
    };
};

export default usePoolState;
